import { useContext } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import NotFound from "../pages/error-page/NotFound";
import MainLayout from "../pages/protected-page/MainLayout";
import StatisticalReportPage from "../pages/protected-page/bao-cao-thong-ke/StatisticalReportPage";
import OverviewTab from "../pages/protected-page/bao-cao-thong-ke/tabs/OverviewTab";
import ServiceReportTab from "../pages/protected-page/bao-cao-thong-ke/tabs/ServiceReportTab";
import ProfileReportTab from "../pages/protected-page/bao-cao-thong-ke/tabs/ProfileReportTab";
import FinanceReportTab from "../pages/protected-page/bao-cao-thong-ke/tabs/FinanceReportTab";
import Quotation from "../pages/protected-page/bao-phi/Page";
import MobilePolicy from "../pages/protected-page/chinh-sach/MobilePolicy";
import PolicyPage from "../pages/protected-page/chinh-sach/PolicyPage";
import PrivacyPolicy from "../pages/protected-page/chinh-sach/policy/PrivacyPolicy";
import RefundPolicy from "../pages/protected-page/chinh-sach/policy/RefundPolicy";
import UpdatePolicy from "../pages/protected-page/chinh-sach/policy/UpdatePolicy";
import UsagePolicy from "../pages/protected-page/chinh-sach/policy/UsagePolicy";
import CategoryServicePage from "../pages/protected-page/danh-sach-dich-vu/CategoryServicePage";
import ListService from "../pages/protected-page/danh-sach-dich-vu/Page";
import PageDetail from "../pages/protected-page/danh-sach-dich-vu/dich-vu/Page";
import ListSignDocument from "../pages/protected-page/danh-sach-hop-dong/Page";
import DetailTicket from "../pages/protected-page/danh-sach-yeu-cau/DetailTicket";
import Support from "../pages/protected-page/danh-sach-yeu-cau/Page";
import TableTicket from "../pages/protected-page/danh-sach-yeu-cau/TableSupport";
import PasswordReset from "../pages/protected-page/dat-lai-mat-khau/Page";
import Guide from "../pages/protected-page/huong-dan-thu-tuc/Page";
import ProcedureDetail from "../pages/protected-page/huong-dan-thu-tuc/ProcedureDetail";
import PaymentHistory from "../pages/protected-page/lich-su-thanh-toan/Page";
import DocumentPage from "../pages/protected-page/mua-ban-so-huu-tri-tue/Page";
import PostsMangement from "../pages/protected-page/quan-ly-bai-viet/Page";
import PostsDetail from "../pages/protected-page/quan-ly-bai-viet/PostsDetail";
import AssetManagementPage from "../pages/protected-page/quan-ly-tai-san/Page";
import DocumentManage from "../pages/protected-page/quan-ly-ho-so/Page";
import EditProfile from "../pages/protected-page/quan-ly-ho-so/ho-so/EditProfile";
import DocumentDetail from "../pages/protected-page/quan-ly-ho-so/ho-so/Page";
import AccountController from "../pages/protected-page/quan-ly-tai-khoan/Page";
import MyAccount from "../pages/protected-page/quan-ly-tai-khoan/tai-khoan-cua-toi/Page";
import EmployeeForm from "../pages/protected-page/quan-ly-tai-khoan/tai-khoan-nhan-vien/NewEmployeeForm";
import StaffList from "../pages/protected-page/quan-ly-tai-khoan/tai-khoan-nhan-vien/Page";
import UserInfo from "../pages/protected-page/quan-ly-tai-khoan/tai-khoan-nhan-vien/UserInfo";
import HomePage from "../pages/protected-page/trang-chu/Page";
import BannerDetail from "../pages/protected-page/trang-chu/components/BannerDetail";
import ForgotPasswordPage from "../pages/public-page/auth-page/forgot-password/forgot-password";
import AuthLayout from "../pages/public-page/auth-page/layout";
import LoginPage from "../pages/public-page/auth-page/login/Login";
import SignupPage from "../pages/public-page/auth-page/signup/Signup";

const AppRoutes = ({ isMobile }) => {
  const { token_client } = useContext(AuthContext);

  const RequireAuth = ({ children }) => {
    return token_client ? children : <Navigate to="/login" />;
  };

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route
          element={
            <RequireAuth>
              <MainLayout isMobile={isMobile} />
            </RequireAuth>
          }
        >
          <Route element={<PolicyPage />}>
            <Route path="/quy-dinh-su-dung" element={<UsagePolicy />} />
            <Route path="/chinh-sach-bao-mat" element={<PrivacyPolicy />} />
            <Route path="/chinh-sach-hoan-tien" element={<RefundPolicy />} />
            <Route path="/chinh-sach-cap-nhat" element={<UpdatePolicy />} />
          </Route>
          <Route
            path="/"
            element={
              isMobile ? <HomePage /> : <ListService isMobile={isMobile} />
            }
          />
          {isMobile && <Route path="/trang-chu" element={<HomePage />} />}
          {isMobile && (
            <Route path="/tai-khoan" element={<AccountController />} />
          )}
          {isMobile && (
            <Route path="/dat-lai-mat-khau" element={<PasswordReset />} />
          )}
          {!isMobile && (
            <Route
              path="/danh-sach-dich-vu"
              element={<ListService isMobile={isMobile} />}
            />
          )}{" "}
          {!isMobile && (
            <Route
              path="/danh-sach-dich-vu/:id"
              element={<CategoryServicePage />}
            />
          )}{" "}
          {isMobile && <Route path="/chinh-sach" element={<MobilePolicy />} />}
          <Route
            path="/danh-sach-dich-vu/dich-vu/:slug/:id"
            element={<PageDetail isMobile={isMobile} />}
          />
          <Route path="/banner/:id" element={<BannerDetail />} />
          <Route
            path="/quan-ly-ho-so"
            element={<DocumentManage isMobile={isMobile} />}
          />
          <Route
            path="/quan-ly-ho-so/ho-so/:id"
            element={<DocumentDetail isMobile={isMobile} />}
          />
          <Route
            path="/quan-ly-ho-so/ho-so/:id/chinh-sua"
            element={<EditProfile isMobile={isMobile} />}
          />
          <Route
            path="/danh-muc-tai-san-tri-tue"
            element={<AssetManagementPage isMobile={isMobile} />}
          />
          <Route
            path="/danh-sach-hop-dong"
            element={<ListSignDocument isMobile={isMobile} />}
          />
          <Route
            path="/huong-dan-thu-tuc"
            element={<Guide isMobile={isMobile} />}
          />
          <Route
            path="/huong-dan-thu-tuc/thu-tuc/:id"
            element={<ProcedureDetail isMobile={isMobile} />}
          />
          <Route
            path="/tai-lieu"
            element={<PostsMangement isMobile={isMobile} />}
          />
          <Route
            path="/tai-lieu/bai-viet/:id"
            element={<PostsDetail isMobile={isMobile} />}
          />
          <Route
            path="/tai-khoan-cua-toi"
            element={<MyAccount isMobile={isMobile} />}
          />
          <Route
            path="/bao-cao-thong-ke"
            element={<StatisticalReportPage isMobile={isMobile} />}
          >
            <Route index element={<Navigate to="/bao-cao-thong-ke/tong-quan" replace />} />
            <Route path="tong-quan" element={<OverviewTab />} />
            <Route path="dich-vu" element={<ServiceReportTab />} />
            <Route path="ho-so" element={<ProfileReportTab />} />
            <Route path="tai-chinh" element={<FinanceReportTab />} />
          </Route>
          <Route
            path="/lich-su-thanh-toan"
            element={<PaymentHistory isMobile={isMobile} />}
          />
          <Route
            path="/danh-sach-nhan-vien"
            element={<MyAccount isMobile={isMobile} />}
          />
          <Route
            path="/tai-khoan-nhan-vien"
            element={<StaffList isMobile={isMobile} />}
          />
          <Route
            path="/tai-khoan-nhan-vien/nhan-vien/:id"
            element={<UserInfo isMobile={isMobile} />}
          />
          <Route
            path="/tai-khoan-nhan-vien/nhan-vien/:id/chinh-sua"
            element={<UserInfo isMobile={isMobile} mode="edit" />}
          />
          <Route
            path="/tai-khoan-nhan-vien/tao-nhan-vien-moi"
            element={<EmployeeForm isMobile={isMobile} />}
          />
          <Route
            path="/danh-sach-yeu-cau"
            element={<TableTicket isMobile={isMobile} />}
          />
          <Route
            path="/danh-sach-yeu-cau/ticket/:id"
            element={<DetailTicket isMobile={isMobile} />}
          />
          <Route
            path="/danh-sach-yeu-cau/them-moi"
            element={<Support isMobile={isMobile} />}
          />
          <Route
            path="/mua-ban-so-huu-tri-tue"
            element={<DocumentPage isMobile={isMobile} />}
          />
          <Route path="/bao-phi" element={<Quotation />} />
        </Route>
        <Route
          element={
            token_client ? (
              <Navigate to="/" />
            ) : (
              <AuthLayout isMobile={isMobile} />
            )
          }
        >
          <Route path="/login" element={<LoginPage isMobile={isMobile} />} />
          <Route path="/signup" element={<SignupPage isMobile={isMobile} />} />
          <Route
            path="/forgot-password"
            element={<ForgotPasswordPage isMobile={isMobile} />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
